import { useMutation } from '@apollo/client';
import {
  SuccessBookingPageQuery,
  UpdateUserDocument,
  UpdateUserInput,
} from '@website/types/graphqlOperations';
import { Col, Form } from 'react-bootstrap';
import { useForm } from 'react-hook-form';
import PhoneNoInput from '../../forms/fields/PhoneNoInput';
import { SubmitButton } from '../../forms/fields/SubmitButton';

type Props = {
  user: SuccessBookingPageQuery['booking']['user'];
  hideLabel?: boolean;
};

export default function UserPhoneNumberUpdateForm({
  user,
  hideLabel = false,
}: Props) {
  const {
    handleSubmit,
    clearErrors,
    setError,
    control,
    formState: { isSubmitting },
  } = useForm<UpdateUserInput>({
    defaultValues: {
      ...user,
      ...(user.picture && {
        picture: {
          id: user.picture?.id,
        },
      }),
    },
  });

  const [updateUser, { loading }] = useMutation(UpdateUserDocument);

  const submitForm = async (fd: UpdateUserInput) => {
    try {
      await updateUser({
        variables: {
          input: fd,
        },
      });
      alert('Phone number updated successfully');
    } catch (e) {
      if (e.networkError) {
        alert(
          'Internet connection lost - please retry when you are connected.',
        );
      } else {
        alert(e);
      }
    }
  };

  return (
    <Form onSubmit={handleSubmit(submitForm)}>
      <Form.Group controlId="phone">
        {!hideLabel && <Form.Label>Phone number *</Form.Label>}
        <PhoneNoInput
          id="phone"
          name="phone"
          clearErrors={clearErrors}
          setError={setError}
          required
          control={control}
        />
      </Form.Group>
      <Col className="mt-3">
        <SubmitButton
          block
          isSubmitting={isSubmitting || loading}
          text="Save"
        />
      </Col>
    </Form>
  );
}
